"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _DrawerHandler = _interopRequireDefault(require("./DrawerHandler")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _drawer = require("../styles/drawer");

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var Drawer = function (a) {
  function b(a) {
    var d;
    (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.selectTab = (0, _lodash["default"])(function (a) {
      return function () {
        var b = d.props.onTabSelect;
        b && b(a), d.setState({
          selectedTabIndex: a
        });
      };
    }), d.toggleMinimiseState = function () {
      d.setState(function (a) {
        var b = a.isMinimised;
        return {
          isMinimised: !b
        };
      });
    }, d.renderChildren = function () {
      var a = d.props.children,
          b = d.state,
          c = b.selectedTabIndex,
          e = b.isMinimised;
      return e ? null : Array.isArray(a) ? a[c] : a;
    };
    var e = a.startOpen;
    return d.state = {
      isMinimised: !e,
      selectedTabIndex: a.defaultTabIndex ? a.defaultTabIndex : 0
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this,
          b = this.state,
          c = b.isMinimised,
          d = b.selectedTabIndex,
          e = this.props,
          f = e.isVertical,
          g = e.tabIcons,
          h = e.className,
          i = e.size,
          j = !!g.length;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(f ? (0, _drawer.V_MENU_CONTAINER)({
          menuSize: i,
          minimised: c,
          hasTabIcons: j
        }) : (0, _drawer.H_MENU_CONTAINER)({
          menuSize: i,
          minimised: c
        }), "drawer__outer-container", h)
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(f ? (0, _drawer.V_MENU)({
          menuSize: i,
          minimised: c,
          hasTabIcons: j
        }) : (0, _drawer.H_MENU)({
          menuSize: i,
          minimised: c
        }), "drawer__inner-container")
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_drawer.DRAWER_CONTENT_CONTAINER, "drawer__content-container")
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])((0, _drawer.DRAWER_CONTENT)({
          hasTabIcons: j,
          menuSize: i,
          isVertical: f
        }), "drawer__content")
      }, this.renderChildren()), j && _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_drawer.TAB_WRAPPER, "drawer__tab-wrapper")
      }, g.map(function (b, c) {
        return _react["default"].createElement(_Icon["default"], {
          key: "icon-".concat(b),
          name: b,
          className: (0, _classnames["default"])((0, _drawer.TAB_ICON)(d === c), "drawer__tab-icon"),
          onClick: a.selectTab(c),
          color: d === c ? "white" : "nevada",
          hoverColor: "white"
        });
      }))), _react["default"].createElement(_DrawerHandler["default"], {
        className: (0, _classnames["default"])("drawer__handler"),
        isMinimised: c,
        isVertical: !!f,
        visibilityHandler: this.toggleMinimiseState
      })));
    }
  }]), b;
}(_react.PureComponent);

exports["default"] = Drawer, Drawer.defaultProps = {
  tabIcons: [],
  size: 320
};